import React from 'react';
import './Header.css';

const Header = ({ activeSection, onSectionChange }) => {
  return (
    <header className="header">
      <div className="nav-container">
        <div className="logo-section">
          <img src='/assets/images/logos/latest_logo_repedal.jpeg' alt="RePedal Logo" className="logo" />
          <img src='/assets/images/logos/gesh.jpeg' alt="GESH Logo" className="logo" />
        </div>
        <nav className="nav-menu">
          <button 
            className={activeSection === 'home' ? 'nav-item active' : 'nav-item'}
            onClick={() => onSectionChange('home')}
          >
            Home
          </button>
          <button 
            className={activeSection === 'bicycles' ? 'nav-item active' : 'nav-item'}
            onClick={() => onSectionChange('bicycles')}
          >
            Inventory
          </button>
          <button 
            className={activeSection === 'about' ? 'nav-item active' : 'nav-item'}
            onClick={() => onSectionChange('about')}
          >
            About
          </button>
          <button 
            className={activeSection === 'contact' ? 'nav-item active' : 'nav-item'}
            onClick={() => onSectionChange('contact')}
          >
            Contact Us
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;